import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", fillRule: "evenodd", d: "M18 18h-3.086C14.914 10.914 9.086 5.086 2 5.086V2c8.8 0 16 7.2 16 16M4.286 18a2.286 2.286 0 1 0 0-4.571 2.286 2.286 0 0 0 0 4.571m5.371 0h2.972C12.629 12.17 7.829 7.37 2 7.37v2.972A7.66 7.66 0 0 1 9.657 18", clipRule: "evenodd" }));
const SvgFeedLightmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgFeedLightmode;
